import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import { paddingBuilder } from 'styles/themeUtils';

function renderTextBlock(options = {}) {
  const { intlKey, paddingLeft = 3, paddingRight = 3 } = options;

  return (
    <Block
      blockWidth="25%"
      padding={{
        desktop: paddingBuilder.horizontal(paddingLeft, paddingRight),
      }}
    >
      <Typography
        variant="subtitle"
        color="white"
        colorVariant="dark"
        intlKey={intlKey}
      />
    </Block>
  );
}

function SectionStatistics() {
  return (
    <Section
      backgroundColor="#311d33"
      backgroundImageUrl={{
        xs: 'young-people-walking/young-people-walking@0.5x.jpg',
        sm: 'young-people-walking/young-people-walking@0.75x.jpg',
        md: 'young-people-walking/young-people-walking@3x.jpg',
      }}
    >
      {renderTextBlock({ intlKey: 'PRESS.STATISTICS.CUSTOMERS', paddingLeft: 4 })}
      {renderTextBlock({ intlKey: 'PRESS.STATISTICS.APPLICANTS' })}
      {renderTextBlock({ intlKey: 'PRESS.STATISTICS.NUCONTA_CUSTOMERS' })}
      {renderTextBlock({ intlKey: 'PRESS.STATISTICS.CUSTOMERS_AGE_GROUP', paddingRight: 4 })}
    </Section>
  );
}

export default React.memo(SectionStatistics);
